import { EventEmitter, Injectable } from "@angular/core";
import { Subscription } from "rxjs/internal/Subscription";

@Injectable({
  providedIn: "root",
})
export class EventEmitterService {
  invokeComponentFunction = new EventEmitter();
  loginCompleted: Subscription;

  setProfilePictureCompleted: Subscription;
  setProfilePictureFunction = new EventEmitter();

  setNotificationCompleted: Subscription;
  setNotificationFunction = new EventEmitter();
  setHomePageIconColorFunctionCompleted: Subscription;
  setHomePageIconColorFunction = new EventEmitter(); 
  setHomePageDashboardProperty = new EventEmitter<boolean>();
  setDashboardMenuProperty = new EventEmitter<string>();
  setReportedContentIdProperty = new EventEmitter<string>();
  setLoggedInUserDataProperty = new EventEmitter<boolean>();

  setUserProfileCreateIconClickedFunction = new EventEmitter();
  setUserProfileCreateIconClickedEventCompleted:Subscription;
  constructor() {}

  callEvent() {
    this.invokeComponentFunction.emit();
  }

  setProfilePictureEvent(imgUrl) {
    this.setProfilePictureFunction.emit(imgUrl);
  }

  setNotificationDetailsEvent(notificationModel) {
    this.setNotificationFunction.emit(notificationModel);
  }

  setHomePageIconColorEvent(pagename) {
    this.setHomePageIconColorFunction.emit(pagename);
  }
  setPageDashboardProperty(property) {
    this.setHomePageDashboardProperty.emit(property);
  }
  setDashboardMenuStyleProperty(property) {
    this.setDashboardMenuProperty.emit(property);
  }
  setInappropriateProperty(property) {
    this.setReportedContentIdProperty.emit(property);
  }
  setLoggedInUserProperty(property) {
    this.setLoggedInUserDataProperty.emit(property);
  }

  setUserProfileCreateIconClickedEvent(pagename) {
    this.setUserProfileCreateIconClickedFunction.emit(pagename);
  }
}
